import React, {useState, useContext, useEffect, useRef} from "react"

// context
import {SearchContext} from "../../context/SearchContext"

// components
import {Redirect} from "react-router-dom"
import {Block} from "../shared"

// styling and images
import "./HeaderSearch.scss"
import images from "../../images"

let redirectToSearch = false

function HeaderSearch({isOpen, close}) {
  
  // state management
  const [searchText, setSearchText] = useState("");
  
  // context
  const search = useContext(SearchContext)

  // refs
  const refInput = useRef()

  // the filter text in the search context changed
  useEffect(() => {
    if(searchText !== "") {
      if(search.filter.text === "") {
        setSearchText("")
      }
    }
  }, [search.filter.text])

  // if open, we want the textinput to have focus
  useEffect(() => {
    if(isOpen && refInput && refInput.current) {
      refInput.current.focus();
    }
  }, [isOpen])

  // search text changes
  const onChangeSearchText = (e) => {
    setSearchText(e.target.value)
  }

  // text input blurs
  const onBlurSearchText = (e) => {
    close();
  }

  const onClickSearch = e => {
    search.filterByKey("text", searchText.trim())
    close()
    redirectToSearch = true;
  }
  // submit the search
  const onSubmit = (e) => {
    if(e && e.preventDefault) {
      e.preventDefault()
    }
    search.filterByKey("text", searchText.trim())
    close()
    redirectToSearch = true;
  }

  // the content
  let content = (
    <Block>
      <div id="v-header-search" className={isOpen ? 'open':'closed'}>
        <div id="v-header-search-inner">
          <div id="v-header-search-text">
            <input 
              type="text" 
              value={searchText}
              onChange={onChangeSearchText}
              onBlur={onBlurSearchText}
              placeholder="wonach suchst du?"
              ref={refInput}
            />
          </div>
          <div id="v-header-search-button" onMouseDown={onClickSearch}>
            <img src={images.icons.white.search} alt="suchen" />
          </div>
        </div>
      </div>
    </Block>
  )

  
  // redirect to search if necessary
  if(redirectToSearch) {
    redirectToSearch = false
    content = <Redirect to="/" /> 
  }

  // render
  return (
    <form onSubmit={onSubmit}>
      {content}
    </form>
  )
} 

export default HeaderSearch
  
        